import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Modal com o texto do orçamento para o WhatsApp. Na tela do orçamento o texto já vem pronto;
// no formulário, `gerar` manda o que está digitado ao servidor (sem gravar) e preenche o modal.
export default class extends Controller {
  static targets = ["modal", "formulario", "texto", "rotulo", "enviar", "aviso", "erro", "acao"]
  static values = { url: String }

  async gerar() {
    const dados = new FormData(this.formularioTarget)
    dados.delete("pedido")

    this.#preencher({ texto: "", telefone: null })
    this.#pronto(false)
    this.erroTarget.hidden = true
    Modal.getOrCreateInstance(this.modalTarget).show()

    const falha = { erros: ["Não foi possível gerar o texto. Tente de novo."] }
    const resposta = await fetch(this.urlValue, { method: "POST", body: dados, headers: { Accept: "application/json" } }).catch(() => null)
    const resultado = resposta ? await resposta.json().catch(() => falha) : falha

    if (!resposta?.ok) {
      this.erroTarget.textContent = resultado.erros.join(" ")
      this.erroTarget.hidden = false
      return
    }

    this.#preencher(resultado)
    this.#pronto(true)
  }

  async copiar() {
    const texto = this.textoTarget.value

    try {
      await navigator.clipboard.writeText(texto)
    } catch {
      // Sem HTTPS a API de clipboard não existe; a seleção manual ainda funciona.
      this.textoTarget.select()
      document.execCommand("copy")
    }

    this.rotuloTarget.textContent = "Copiado!"
    setTimeout(() => { this.rotuloTarget.textContent = "Copiar" }, 2000)
  }

  // O wa.me abre a conversa do número com o texto já digitado, no app ou no WhatsApp Web;
  // quem envia é a atendente.
  enviar() {
    const telefone = this.enviarTarget.dataset.telefone
    const texto = encodeURIComponent(this.textoTarget.value)

    window.open(`https://wa.me/${telefone}?text=${texto}`, "_blank", "noopener")
  }

  #preencher({ texto, telefone }) {
    this.textoTarget.value = texto
    this.enviarTarget.dataset.telefone = telefone ?? ""
    this.enviarTarget.hidden = !telefone
    this.avisoTarget.hidden = Boolean(telefone)
  }

  #pronto(pronto) {
    this.acaoTargets.forEach((botao) => { botao.disabled = !pronto })
  }
}
